/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/sun_medium'
export default icon
